import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useState } from 'react';
import { useParams } from 'react-router';
import { TabContext, TabPanel } from '@mui/lab';
import TabList from '@mui/lab/TabList';
import { Box, Tab } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';

import { RootContainer } from '../../components/nav/RootContainer';
import { BusinessDetailsCard } from './components/BusinessDetailsCard';
import { BusinessNotesCard } from './components/Notes';

export default function SignupDetails() {
    const { id } = useParams();
    const activePage = useActivePage();
    const [value, setValue] = useState('details');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const signupDetailsQuery = useQuery({
        queryKey: ['businessSignup', id],
        queryFn: () => Api.Businesses.getSignupById(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        { title: 'Details', path: `${activePage?.path}/${id}` },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={signupDetailsQuery}>
                {data => (
                    <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={value}>
                            <Box
                                sx={{ borderBottom: 1, borderColor: 'divider' }}
                            >
                                <TabList
                                    onChange={handleChange}
                                    aria-label="sign-up tabs"
                                >
                                    <Tab label="Details" value="details" />
                                    <Tab label="Notes" value="notes" />
                                </TabList>
                            </Box>
                            <TabPanel value="details">
                                <BusinessDetailsCard businessDetails={data} />
                            </TabPanel>
                            <TabPanel value="notes">
                                <BusinessNotesCard
                                    businessSignup={data}
                                    refetchData={signupDetailsQuery.refetch}
                                />
                            </TabPanel>
                        </TabContext>
                    </Box>
                )}
            </QueryRenderer>
        </RootContainer>
    );
}
